import React, { FC } from 'react';

import { TEXTS } from 'application/pages/BillingPage/renderer/texts';
import DeclensionUtils from 'application/utils/DeclensionUtils';
import { ModalProps, ModalTypes } from 'application/providers/ModalProvider';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';

import useChangePricePlanPeriodConfirmModal from '../../model/useChangePricePlanPeriodConfirmModal';

import styles from './ChangePricePlanPeriodConfirmModal.module.scss';

const ChangePricePlanPeriodConfirmModal: FC<ModalProps[ModalTypes.BILLING_CHANGE_PRICE_PLAN_PERIOD_CONFIRM]> = ({
  periodTitle,
  payFrequencyMonth,
  onSubmit,
  close,
}) => {
  const { renewableLicensesLength, hasTrialLicenses, formatNextBillingDate, loading, hasInactiveLicenses } =
    useChangePricePlanPeriodConfirmModal();

  const confirm = () => {
    onSubmit();
    close();
  };

  return (
    <ModalScreen
      title={TEXTS.BILLING_CHANGE_RATE_CONFIRM_MODAL_TITLE}
      titlePlacement="left"
      hideCloseButton
      actionButtons={[
        <Button
          key="button_confirm_change_rate_modal"
          elementId="button_confirm_change_rate_modal"
          isLoading={loading}
          type={ButtonType.PRIMARY}
          onClick={confirm}>
          {TEXTS.BILLING_CHANGE_RATE_CONFIRM_MODAL_CONFIRM}
        </Button>,
        <Button
          key="button_cancel_change_rate_modal"
          elementId="button_cancel_change_rate_modal"
          type={ButtonType.SECONDARY}
          isLoading={loading}
          onClick={() => close()}>
          {TEXTS.BILLING_BIND_CARD_MODAL_CANCEL}
        </Button>,
      ]}>
      {hasInactiveLicenses ? (
        <div className={styles.description}>{TEXTS.BILLING_CHANGE_RATE_BUTTON_INACTIVE_STATUS(payFrequencyMonth)}</div>
      ) : (
        <div className={styles.description}>
          <span>
            {TEXTS.TOTAL_PRICE_BLOCK_FIRST_DEBITING_CONFIRM_TEXT(hasTrialLicenses, periodTitle.toLowerCase())}{' '}
          </span>
          <span>
            {renewableLicensesLength}
            &nbsp;
            {`адрес${DeclensionUtils.pluralEnding(renewableLicensesLength)}`}{' '}
          </span>
          <span>{TEXTS.TOTAL_PRICE_BLOCK_FIRST_DEBITING_DATE(formatNextBillingDate)}</span>
        </div>
      )}
    </ModalScreen>
  );
};

export default React.memo(ChangePricePlanPeriodConfirmModal);
